import React from "react";
import { Box, Typography } from "@mui/material";
import AcxExpansion from "components/UI/AcxExpansion";
import theme from "Theme/AppTheme";

type SectionProps = {
    heading: string;
    subHeading: string;
    children: React.ReactNode;
    shouldStartExpanded?: boolean;
};

const Section: React.FC<SectionProps> = ({
    heading,
    subHeading,
    children,
    shouldStartExpanded,
}) => {
    return (
        <AcxExpansion
            expanded={shouldStartExpanded}
            headerSx={{
                padding: theme.spacing(2, 1),
                borderTopLeftRadius: theme.shape.borderRadius * 2,
                borderTopRightRadius: theme.shape.borderRadius * 2,
            }}
            header={
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Typography sx={{ fontWeight: 600, fontSize: 16 }}>
                        {heading}
                    </Typography>
                    <Typography>{subHeading}</Typography>
                </Box>
            }
            body={
                <Box
                    sx={{
                        background: theme.palette.white.main,
                        padding: theme.spacing(0, 2),
                        borderBottomLeftRadius: theme.shape.borderRadius * 2,
                        borderBottomRightRadius: theme.shape.borderRadius * 2,
                    }}
                >
                    <Box
                        sx={{
                            borderTop: `1px solid ${theme.palette.grey[300]}`,
                            padding: theme.spacing(2, 0),
                        }}
                    >
                        <Box
                            sx={{
                                padding: 2,
                                background: theme.palette.grey[100],
                                borderRadius: 2,
                                display: "flex",
                                flexDirection: "column",
                                gap: 1,
                            }}
                        >
                            {children}
                        </Box>
                    </Box>
                </Box>
            }
        ></AcxExpansion>
    );
};

export default Section;
